<template>
  <div class="sign">
    <h1>PEISO</h1>
    <div class="input-item">
      <!--<el-input type="text" :maxlength="mobile.slice(0, 1) === '4' ? 9 : 10" @keyup.enter.native="sign" v-model="mobile" placeholder="Mobile" @input="validate('mobile')" />-->
      <el-input maxlength="30" type="text" @keyup.enter.native="sign" v-model="mobile" placeholder="Username" />
      <div class="line" :class="{'warn': mobileWarn}"></div>
    </div>
    <div class="input-item" style="margin-bottom:20px">
      <el-input type="password" @keyup.enter.native="sign" maxlength="16" v-model="password" placeholder="Password" @input="validate('psd')" />
      <div class="line" :class="{'warn': passwordWarn}"></div>
    </div>
    <p><span @click="forget">Forgot Password?</span></p>
    <button v-if="!isLoading" @click="sign">Login</button>
    <el-button v-if="isLoading" class="mt-3 mb-3" type="transparent">
        <i class="el-icon-loading" style="font-size: 20px; font-weight: 900; color: #EA3796;"></i>
        Logging in...
    </el-button>
  </div>
</template>

<script>
import api from '../../api/login'
import apiV2 from '../../api/api'
import {mapMutations, mapState} from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      mobile: '',
      mobileWarn: false,
      password: '',
      passwordWarn: false,
      isLoading: false,
      isVenueSummary: parseInt(process.env.IS_ENABLE_VENUE_SUMMARY),
      masterId: process.env.MASTER_ID,
      instance_type: process.env.INSTANCE_TYPE
    }
  },
  created () {
    // if (this.$route.query.code && this.$route.query.x && this.$route.query.state.slice(0, 4) === 'xero') {
    if (this.$route.query.code && this.$route.query.state == 'xero') {
      console.log('xero')
      localStorage.setItem('xeroCode', this.$route.query.code)
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
      window.open('','_self').close()
      window.location.href = "about:blank"
      }else {
      window.opener = null;
      window.open("about:blank", "_self");
      window.close();
      }
    }
    // deputy
    if (this.$route.query.code && !this.$route.query.state && !this.$route.query.type) {
      if (localStorage.getItem('instance_type') == 'lucas') {
        console.log(process.env.IS_MAIN, `${process.env.LUCAS_URI}login?code=${this.$route.query.code}`)
        if (process.env.IS_MAIN == '1') {
          window.location.replace(`${process.env.LUCAS_URI}login?code=${this.$route.query.code}`, "_blank")
        }
      } else {
        localStorage.setItem('deputyCode', this.$route.query.code)
        console.log('deputy lucas')
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
        window.open('','_self').close()
        window.location.href = "about:blank"
        }else {
        window.opener = null;
        window.open("about:blank", "_self");
        window.close();
        }
      }

    }
    // tanda
    if (this.$route.query.code && !this.$route.query.state && this.$route.query.type  && this.$route.query.type === 'tanda') {
      console.log('tanda')
      localStorage.setItem('tandaCode', this.$route.query.code)
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
      window.open('','_self').close()
      window.location.href = "about:blank"
      }else {
      window.opener = null;
      window.open("about:blank", "_self");
      window.close();
      }
    }

    // SQUARE
    if (this.$route.query.code && this.$route.query.state == 'peiso_login') {
        localStorage.setItem('squareCode', this.$route.query.code)
        let userAgent = navigator.userAgent;
        if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
          window.open('','_self').close()
          window.location.href = "about:blank"
        }else {
          window.opener = null;
          window.open("about:blank", "_self");
          window.close();
        }
    }

    // OOLIO
    if (this.$route.query.code && this.$route.query.integration == 'oolio') {
        console.log('oolioCode', this.$route.query.code)
        localStorage.setItem('oolioCode', this.$route.query.code)
        let userAgent = navigator.userAgent;
        if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
          window.open('','_self').close()
          window.location.href = "about:blank"
        }else {
          window.opener = null;
          window.open("about:blank", "_self");
          window.close();
        }
    }


    //lightspeed k-series


    if (this.$route.query.error) {
      console.log('kseries')
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
      window.open('','_self').close()
      window.location.href = "about:blank"
      }else {
      window.opener = null;
      window.open("about:blank", "_self");
      window.close();
      }
    }

    if (this.$route.query.instance_type) {
      if (process.env.IS_MAIN == '1') {
        localStorage.setItem('instance_type', this.$route.query.instance_type)
      }
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
      window.open('','_self').close()
      window.location.href = "about:blank"
      }else {
      window.opener = null;
      window.open("about:blank", "_self");
      window.close();
      }
    }

  },
  methods: {
    ...mapMutations([
      'closeDashboard'
    ]),


    sign () {
      var that = this
      if (that.mobile.replace(/\s+/g,'') == '') {
        that.mobileWarn = true
      }
      if (that.password.replace(/\s+/g,'') == '') {
        that.passwordWarn = true
      }
      if (that.mobile.replace(/\s+/g,'') == '' || that.password.replace(/\s+/g,'') == '') {
        return
      }
      let pat={
        userName:this.mobile,
        password:this.password
      }
      this.isLoading = true
      this.closeDashboard()
      api.login(pat,res=>{
        let {code,data,message}=res.data
        if(code==0){
          const venueId = localStorage.getItem('venueId');
          if (data.venueId != venueId) {
            localStorage.removeItem('venues');
          }
          localStorage.setItem('venueId', data.venueId);

          window.sessionStorage.setItem('doshiiLinked',data.doshiiLinked ? '1' : '0')
          window.sessionStorage.setItem('userName',data.userName)
          window.sessionStorage.setItem('token',data.token)
          window.sessionStorage.setItem('deputyFlag',data.deputyFlag)
          window.sessionStorage.setItem('xeroFlag',data.xeroFlag)
          window.sessionStorage.setItem('popUpFullTimeEmployee',data.popUpFullTimeEmployee)

          window.sessionStorage.setItem('xero',data.xeroFlag)
          window.sessionStorage.setItem('deputy',data.deputyFlag)

          window.sessionStorage.setItem('noIncome1', '1')
          window.sessionStorage.setItem('noIncome2', '1')
          window.sessionStorage.setItem('venueName', data.venueName)

          window.sessionStorage.setItem('venueType', data.venueType)
          sessionStorage.setItem('isPinNeeded', 0)

          if (data.terminalsList)
            window.sessionStorage.setItem('terminalsList', JSON.stringify(data.terminalsList))
          // 2021/12/30
          // window.sessionStorage.setItem('pinstatus', true)

          if (data.pin == null) {
            window.sessionStorage.setItem('pinstatus', false)
            window.sessionStorage.setItem('pin', '')
          } else {
            window.sessionStorage.setItem('pinstatus', true)
            window.sessionStorage.setItem('pin', data.pin)
          }

          if (data.venueType == 2) {
            sessionStorage.setItem('venueType', 1)
            sessionStorage.setItem('isPinNeeded', 1)
            sessionStorage.setItem('isSingleAccount', 1)
            sessionStorage.setItem('subVenueId', data.venueId)
            sessionStorage.setItem('subVenueName', data.venueName)
            this.loadDatum()
          }
          else if (data.venueType === 1) {
            if (data.venueId == this.masterId) {
                sessionStorage.setItem('isAllowedUnlinking', 1)
            }
            if (this.isVenueSummary) {
              if (data.venueId == this.masterId) {
                sessionStorage.setItem('isMaster', 1)
              } else {
                sessionStorage.setItem('isMaster', 0)
              }
            } else {
              sessionStorage.setItem('isMaster', 1)
            }


            api.getSubVenueList({
                callback: (res) => {
                    that.loading = false
                    let {code,data,message}=res.data
                    if (code === 0) {
                        if (data.length === 1) {
                          sessionStorage.setItem('isSingleAccount', 1)
                          sessionStorage.setItem('subVenueId', data[0].venueId)
                          sessionStorage.setItem('subVenueName', data[0].venueName)
                          this.loadDatum()
                        } else {
                          sessionStorage.setItem('isSingleAccount', 0)
                          this.$router.push('/venueselect')
                        }
                    } else {
                        Utils.alert('',message,'error')
                    }
                }
            })

            // this.$router.push('/venueselect')
          }
          this.isLoading = false
        }else{
          Utils.alert2('',message,'error')
          this.isLoading = false
        }
      })
    },
    async loadDatum() {
      await apiV2.checkDashboardV2()
      this.$router.push('/dashboard')
    },
    validate (txt) {
      var that = this
      if (txt == 'mobile') {
        that.mobile = that.mobile.replace(/[^\d]/g,'')
        if (that.mobile.length > 0) {
          that.mobileWarn = false
        }
      } else {
        if (that.password.length > 0) {
          that.passwordWarn = false
        }
      }
    },
    forget () {
      this.$router.push('/forget')
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.sign{
  width: 410px;
  height: 432px;
  background: var(--background-color-4);
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -216px 0 0 -205px;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 50px 50px 0 50px;
  h1{
    font-size: 30px;
    text-align:center;
    letter-spacing: 10px;
    margin-bottom: 60px;
    color: var(--text-color);
    span{
      transition: all .5s;
      top: -30px;
      position: relative;
      opacity: 0;
    }
  }
  .show{
    .span0{
      top: 0;
      transition: all .7s;
      opacity: 1;
    }
    .span1{
      top: 0;
      transition: all 0.55s;
      opacity: 1;
    }
    .span2{
      top: 0;
      transition: all 0.4s;
      opacity: 1;
    }
    .span3{
      top: 0;
      transition: all 0.25s;
      opacity: 1;
    }
    .span4{
      top: 0;
      transition: all 0.1s;
      opacity: 1;
    }
  }
  .input-item{
    margin-bottom: 35px;
    position: relative;
    .line{
      width: 0;
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      border-bottom: 1px solid #EA3796;
      overflow: hidden;
      transition: all .3s;
    }
    .warn{
      width: 100%;
    }
  }
  p{
    font-size: 12px;
    text-align:right;
    color: var(--text-color);
    margin-bottom: 40px;
    span{
      cursor: pointer;
    }
  }
  button{
    display: block;
    outline: none;
    background: none;
    cursor: pointer;
    width: 310px;
    height: 50px;
    border: 2px solid #EA3796;
    color: #EA3796;
    margin: 0 auto;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue